import {connect} from 'react-redux';
import ShortPositionReportDashboard from '../components/ShortPositionReportDashboard';

import {
  // Generate Short Position Report
  generateShortPositionReport,
  initGenerateShortPositionReportActionStatus,

  // Load Short Position Report
  loadShortPositionReport,
  initLoadShortPositionReportActionStatus,

  // Open/Reset Short Position Report Check Result Modal Dialog
  openShortPositionReportCheckResultModalDialog,
  resetShortPositionReportCheckResultModalDialog,

  // Load Short Position Report Check Result
  loadShortPositionReportCheckResult,
  initLoadShortPositionReportCheckResultActionStatus,

  // Report Short Position Report
  reportShortPositionReport,
  initReportShortPositionReportActionStatus,

} from '../shortPositionReportActions';

const mapStateToProps = state => {
  return {
    // Grdi Columns
    shortPositionReportGridColumns: state.shortPositionReport.shortPositionReportGridColumns,
    masShortPositionReportGridColumns: state.shortPositionReport.masShortPositionReportGridColumns,
    shortPosReportChkResultGridColumns: state.shortPositionReport.shortPosReportChkResultGridColumns,
    masShortPosReportChkResultGridColumns: state.shortPositionReport.masShortPosReportChkResultGridColumns,

    // Short Position Report
    shortPositionReportArray: state.shortPositionReport.shortPositionReportArray,

    // Generate Short Position Report Action Status
    generateShortPositionReportActionStatus: state.shortPositionReport.generateShortPositionReportActionStatus,
    generateShortPositionReportErrMsg: state.shortPositionReport.generateShortPositionReportErrMsg,

    // Load Short Position Report Action Status
    loadShortPositionReportActionStatus: state.shortPositionReport.loadShortPositionReportActionStatus,
    loadShortPositionReportErrMsg: state.shortPositionReport.loadShortPositionReportErrMsg,

    // Short Position Report Check Result Modal Dialog
    shortPositionReportCheckResultControlModal: state.shortPositionReport.shortPositionReportCheckResultControlModal,

    // Short Position Report Check Result
    shortPosReportChkResult: state.shortPositionReport.shortPosReportChkResult,

    // Load Short Position Report Check Result Action Status
    loadShortPositionReportCheckResultActionStatus: state.shortPositionReport.loadShortPositionReportCheckResultActionStatus,
    loadShortPositionReportCheckResultErrMsg: state.shortPositionReport.loadShortPositionReportCheckResultErrMsg,

    // Report Short Position Report
    reportShortPositionReportActionStatus: state.shortPositionReport.reportShortPositionReportActionStatus,
    reportFileArray: state.shortPositionReport.reportFileArray,
    reportShortPositionReportErrMsg: state.shortPositionReport.reportShortPositionReportErrMsg,
  };
} 

const mapDispatchToProps = dispatch => {
  return {
    // Generate Short Position Report
    generateShortPositionReport: (fundCode, dateString, securitiesRegulator) => dispatch(generateShortPositionReport(fundCode, dateString, securitiesRegulator)),
    initGenerateShortPositionReportActionStatus: () => dispatch(initGenerateShortPositionReportActionStatus()),

    // Load Short Position Report
    loadShortPositionReport: (fundCode, dateString, securitiesRegulator) => dispatch(loadShortPositionReport(fundCode, dateString, securitiesRegulator)),
    initLoadShortPositionReportActionStatus: () => dispatch(initLoadShortPositionReportActionStatus()),

    // Open/Reset Short Position Report Check Result Modal Dialog
    openShortPositionReportCheckResultModalDialog: (fundCode, dateString, securitiesRegulator) => dispatch(openShortPositionReportCheckResultModalDialog(fundCode, dateString, securitiesRegulator)),
    resetShortPositionReportCheckResultModalDialog: () => dispatch(resetShortPositionReportCheckResultModalDialog()),

    // Load Short Position Report Check Result
    loadShortPositionReportCheckResult: (fundCode, dateString, securitiesRegulator) => dispatch(loadShortPositionReportCheckResult(fundCode, dateString, securitiesRegulator)),
    initLoadShortPositionReportCheckResultActionStatus: () => dispatch(initLoadShortPositionReportCheckResultActionStatus()),

    // Report Short Position Report
    reportShortPositionReport: (fundCode, dateString, securitiesRegulator) => dispatch(reportShortPositionReport(fundCode, dateString, securitiesRegulator)),
    initReportShortPositionReportActionStatus: () => dispatch(initReportShortPositionReportActionStatus()),

  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShortPositionReportDashboard);